export default "__VITE_ASSET__BG41rUyp__"